<template>
  <div class="card" style="margin-bottom: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i>
            LEADS CERRADOS SIN CONVERTIR
          </p>
          <p class="text-muted" style="margin: 0 10px 10px; font-size: 13px">
            Ventas con <code>closed=true</code> y <code>converted=false</code>.
            No aparecen en Leads ni en Ventas.
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <Skeletor :shimmer="true" height="200" width="100%" />
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="leads"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Última actualización</th>
            <th>Fecha/Hora</th>
            <th>ID Venta</th>
            <th data-priority="2">Referidor</th>
            <th data-priority="1">Nombre Completo</th>
            <th>Celular</th>
            <th>Email</th>
            <th>Etapa negocio</th>
            <th>Estado lead</th>
            <th data-priority="3">Observación</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";

DataTable.use(DataTablesCore);

function formatTimestamp(value) {
  if (!value) return "—";
  const date =
    typeof value?.toDate === "function"
      ? value.toDate()
      : value?._seconds
        ? new Date(value._seconds * 1000)
        : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("es-ES", {
    timeZone: "America/Guayaquil",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatStatusLabel(value) {
  if (!value) return "—";
  const statusMap = {
    NEW: "Nuevo",
    BAD_TIMING: "Llamar más tarde",
    QUALIFICADO: "Calificado",
    UNQUALIFIED: "Descalificado",
    "Venta Perdida": "Venta perdida",
    "Venta Ganada": "Venta ganada",
  };
  const mapped = statusMap[value] ?? value;
  return mapped.charAt(0).toUpperCase() + mapped.slice(1).toLowerCase();
}

function buildObservation(data) {
  const dealstage = (data.dealstage || "").trim();
  const hsStatus = (data.hs_lead_status || "").trim();
  const notes = [];

  if (dealstage === "Cierre ganado" && hsStatus !== "Venta Ganada") {
    notes.push("Deal ganado pero lead status no coincide");
  }
  if (dealstage === "Cierre perdido" && hsStatus === "Venta Ganada") {
    notes.push("Lead ganado pero deal perdido");
  }
  if (data.commissionPendingCredit === true) {
    notes.push("Pendiente acreditación de comisión");
  }
  if (!dealstage && !hsStatus) {
    notes.push("Sin estado en HubSpot");
  }

  return notes.length ? notes.join(" · ") : "Revisar sincronización HubSpot";
}

export default {
  components: {
    DataTable,
  },
  props: ["tokenAuth"],
  data() {
    const role = localStorage.getItem("session");

    return {
      loading: true,
      leads: [],
      role,
      columns: [
        {
          data: null,
          render: function (data) {
            return formatTimestamp(data.date_update);
          },
        },
        { data: "dateFormatted" },
        { data: "contactId" },
        { data: "referrer" },
        {
          data: null,
          render: function (data) {
            return `${data.firstname || ""} ${data.lastname || ""}`.trim();
          },
        },
        { data: "phone" },
        { data: "email" },
        {
          data: null,
          render: function (data) {
            return formatStatusLabel(data.dealstage);
          },
        },
        {
          data: null,
          render: function (data) {
            return formatStatusLabel(data.hs_lead_status);
          },
        },
        {
          data: null,
          render: function (data) {
            return buildObservation(data);
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Ingrese algún dato",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  mounted() {
    this.getClosedPending();
  },
  methods: {
    refresh() {
      this.getClosedPending();
    },

    getClosedPending() {
      this.loading = true;
      this.$https
        .post("/leads/getAllClosedPending", {
          tokenAuth: this.tokenAuth,
          role: this.role,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.leads = response.data.leads || [];
            this.loading = false;
          } else {
            this.loading = true;
            if (response.data.code == 401) {
              localStorage.removeItem("userData");
              this.$store.state.user = "";
              this.$router.push({ name: "Signin" });
            }
          }
        })
        .catch(() => {
          this.getClosedPending();
        });
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";
</style>
